import {
  type DashboardActions,
  InternalMembersActions,
} from '@store/reducers/dashboard/actions'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'

export function* suspend({
  payload,
}: ReturnType<typeof DashboardActions.members.suspend>) {
  const { workspaceId, id } = payload
  yield put(
    InternalMembersActions.update({ ...payload, activity: 'suspended' })
  )
  try {
    yield call(NestClient.membership.suspend, workspaceId, id)
    yield call(sendGtmEvent, GtmTriggerName.TEAM_MEMBER_SUSPEND)
  } catch (e) {
    console.error('Error while suspending member', e)
    yield put(GeneralErrorNotification)
  }
  yield put(InternalMembersActions.fetchList({ workspaceId }))
}
